import React, { useEffect } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { initializeAuth } from './store/slices/authSlice'

// Layout Components
import TeacherLayout from './layout/TeacherLayout'
import LoadingScreen from './components/LoadingScreen/LoadingScreen'

// Auth Components
import Login from './pages/Auth/Login'

// Main Pages
import Overview from './pages/Overview/Overview'
import Batches from './pages/Batches/Batches'
import BatchDetail from './pages/Batches/BatchDetail'
import Lectures from './pages/Lectures/Lectures'
import LectureDetail from './pages/Lectures/LectureDetail'
import CreateLecture from './pages/Lectures/CreateLecture'
import ScheduleLectures from './pages/Lectures/ScheduleLectures'
import Students from './pages/Students/Students'
import StudentDetail from './pages/Students/StudentDetail'
import Profile from './pages/Profile/Profile'
import Settings from './pages/Settings/Settings'

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isInitialized } = useSelector((state) => state.auth)
  
  if (!isInitialized) {
    return <LoadingScreen />
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }
  
  return children
}

function App() {
  const dispatch = useDispatch()
  const { isInitialized, isLoading } = useSelector((state) => state.auth)
  const currentTheme = useSelector((state) => state.theme.current)

  useEffect(() => {
    dispatch(initializeAuth())
  }, [dispatch])

  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.documentElement.setAttribute('data-theme', currentTheme)
    }
  }, [currentTheme])

  if (!isInitialized || isLoading) {
    return <LoadingScreen />
  }

  return (
    <Routes>
      {/* Auth Routes */}
      <Route path="/login" element={<Login />} />
      
      {/* Protected Routes */}
      <Route 
        path="/" 
        element={
          <ProtectedRoute>
            <TeacherLayout />
          </ProtectedRoute>
        }
      >
  {/* Overview */}
  <Route index element={<Overview />} />
        
        {/* Batches */}
        <Route path="batches" element={<Batches />} />
        <Route path="batches/:batchId" element={<BatchDetail />} />
        
        {/* Lectures */}
        <Route path="lectures" element={<Lectures />} />
        <Route path="lectures/new" element={<CreateLecture />} />
        <Route path="lectures/schedule" element={<ScheduleLectures />} />
        <Route path="lectures/:lectureId" element={<LectureDetail />} />
        
        {/* Students */}
        <Route path="students" element={<Students />} />
        <Route path="students/:studentId" element={<StudentDetail />} />
        
        {/* Profile & Settings */}
        <Route path="profile" element={<Profile />} />
        <Route path="settings" element={<Settings />} />
      </Route>
      
      {/* Catch all - redirect to dashboard */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default App